import(/* webpackMode: "eager" */ "E:\\Final Projects Repo\\LocoBuzzWebsite\\locobuzz-website\\app\\platform\\market-research\\page.js");
